<template>
	<div class="intergral-container">
		<div class="integralBox">
			<div class="integralNum">
				<div class="integralTitle">
					积分总额
				</div>
				<div class="integral">
					{{userInfo.score ? userInfo.score : '0'}}
				</div>
			</div>
			<div class="rechange" @click="pointsPackageShow = true">立即充值</div>
		</div>
		<div class="recordTitle">收入明细</div>
		<div class="recordList" v-if="recordDara.length">
			<div class="recordItem" v-for="(item,index) in recordDara" :key="index">
				<div class="recordType">
					{{item.content}}
					<div class="time">
						{{item.create_time}}
					</div>
				</div>
				<div class="price">{{item.price > 0 ? '+ ' + item.price : '- ' + (-1 * item.price)}}</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<PagePagination style="padding: .4rem 0 0;" :currentPage="currentPage" :total="total"
			@current-change="onPageChange" />
		<PointsPackageDialog :show="pointsPackageShow" @orderAddSuc="orderAddSuc" @close="pointsPackageShow = false" />
		<PayDialog :show="dialogPayViable" :orderType="2" :payUrl="payUrl" :orderId="orderId"
			@close="dialogPayViable = false" @success="paySucPop = true;userDetails();balanceMoneyList();" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'充值成功'" @clickOk="paySucPop = false"
			v-if="paySucPop" />
	</div>
</template>

<script>
	import PayDialog from '../components/PayDialog.vue'
	import PointsPackageDialog from '../../src/components/PointsPackageDialog.vue'
	export default {
		name: 'MyIntegral',
		components: {
			PayDialog,
			PointsPackageDialog
		},
		data() {
			return {
				dialogPayViable: false,
				paySucPop: false,
				currentPage: 1,
				total: 0,
				recordDara: [],
				errPop: false,
				errorDesc: '',
				errorDescTwo: '',
				tipPop: false,
				sucPop: false,
				userInfo: {},
				orderId: '',
				payUrl: '',
				pointsPackageShow: false,
			}
		},
		created() {
			this.userDetails()
			this.balanceMoneyList()
		},
		methods: {
			onPageChange(newPage) {
				this.currentPage = newPage
				this.balanceMoneyList()
			},
			balanceMoneyList() {
				this.$api.post('/UserD/integral_money_list', {
					p: this.currentPage
				}).then(res => {
					if (res.code == 1) {
						this.total = res.data.count
						this.recordDara = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(result => {
					if (result.code == 1) {
						this.userInfo = result.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			orderAddSuc(orderId) {
				this.$api.post('/Tonglian/order_pay', {
					id: orderId,
				}).then(res => {
					if (res.code == 1) {
						this.payUrl = res.data
						this.orderId = orderId
						this.dialogPayViable = true
					}
				}).catch(err => {
					console.log(err);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.intergral-container {
		padding: .4rem .4rem;
	}

	@media (max-width: 480px) {
		.integralBox {
			width: 100%;
			height: 2.72rem;
			border-radius: .04rem;
			background: rgba(216, 216, 216, .1);
			box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: .32rem .36rem .4rem;

			.integralNum {
				height: 1.28rem;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.integralTitle {
					font-weight: 400;
					font-size: .28rem;
					color: #B9B9BB;
					line-height: .36rem;
				}

				.integral {
					font-weight: 700;
					font-size: .8rem;
					color: #FFFFFF;
					line-height: .72rem;
				}
			}

			.rechange {
				display: flex;
				align-items: center;
				justify-content: center;
				width: 1.8rem;
				height: .72rem;
				background: #1673E6;
				border-radius: .36rem;
				font-weight: 500;
				font-size: .28rem;
				color: #FFFFFF;
				line-height: .4rem;
				cursor: pointer;
			}
		}

		.recordTitle {
			margin-top: .32rem;
			font-weight: 600;
			font-size: .32rem;
			color: rgba(255, 255, 255, .8);
			line-height: .44rem;
		}

		.recordList {
			display: flex;
			flex-direction: column;
			overflow-y: auto;

			.recordItem {
				height: 1.4rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: .24rem 0;
				border-bottom: .01rem solid rgba(204, 204, 204, .2);

				.recordType {
					display: flex;
					flex-direction: column;
					font-weight: 400;
					font-size: .32rem;
					color: rgba(255, 255, 255, .8);

					.time {
						font-weight: 400;
						font-size: .24rem;
						color: rgba(115, 118, 124, .6);
					}
				}
			}

			.price {
				font-weight: 500;
				font-size: .32rem;
				color: rgba(147, 224, 61, 1);
			}
		}
	}

	@media (min-width: 481px) {
		.integralBox {
			width: 100%;
			height: 1.36rem;
			border-radius: .04rem;
			background: rgba(216, 216, 216, .1);
			box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.5);
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: .32rem .36rem .4rem;

			.integralNum {
				height: .64rem;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.integralTitle {
					font-weight: 400;
					font-size: .14rem;
					color: #B9B9BB;
					line-height: .18rem;
				}

				.integral {
					font-weight: 700;
					font-size: .4rem;
					color: #FFFFFF;
					line-height: .36rem;
				}
			}

			.rechange {
				display: flex;
				align-items: center;
				justify-content: center;
				width: .9rem;
				height: .36rem;
				background: #1673E6;
				border-radius: .18rem;
				font-weight: 500;
				font-size: .14rem;
				color: #FFFFFF;
				line-height: .2rem;
				cursor: pointer;
			}
		}

		.recordTitle {
			margin-top: .16rem;
			font-weight: 600;
			font-size: .16rem;
			color: rgba(255, 255, 255, .8);
			line-height: .22rem;
		}

		.recordList {
			display: flex;
			flex-direction: column;
			overflow-y: auto;

			.recordItem {
				height: .7rem;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: .12rem 0;
				border-bottom: .01rem solid rgba(204, 204, 204, .2);

				.recordType {
					display: flex;
					flex-direction: column;
					font-weight: 400;
					font-size: .16rem;
					color: rgba(255, 255, 255, .8);

					.time {
						font-weight: 400;
						font-size: .12rem;
						color: rgba(115, 118, 124, .6);
					}
				}
			}

			.price {
				font-weight: 500;
				font-size: .16rem;
				color: rgba(147, 224, 61, 1);
			}
		}
	}
</style>